import styled from "styled-components";
import {Link} from "react-router-dom"

export const Modal = styled.div`
  background-color: ${props => props.background ? props.background : "rgba(250, 250, 250, 0.75)"};

   position: fixed;
   backdrop-filter: blur(3px);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* display: none; */
    outline: 0;
    transition: opacity linear;
    z-index: 999;
`;

// Inputss

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.25rem 0;

  label{
    margin-bottom: 0.5rem;
    display: inline-block;
    font-size: 13px;
    line-height: 1;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    font-weight: 700;
    opacity: 0.7;
  } 
  input{
    color: gray;
  }

  input,select, &>div{
    padding: 0.65rem 1rem;
    border-radius: 0.25rem;
    /* cursor: ; */
    font-size: 0.85rem;
    border-width: 1.5px;
    background-color: white;

    &:focus, &:focus-within{
      border-color: var(--thatYellow);
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    }
  }
  &>div{
    display: flex;
    align-items: center;
    input{
     padding: 0;
    border-radius: 0;
    border-width: 0;
    background-color: inherit;
    width: 100%;
    &:focus{
      border-color: 0;
      box-shadow: none;
    }
  }
  span{
    
    display: inline-block;
    font-size: 13px;
    line-height: 1;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    font-weight: 700;
    color: gray;
  }
  }
`;

export const ConverterInput = styled.div`
  border: 1px solid #dbdfea;
  padding: 0.75rem .75rem;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  transition-duration: 200ms;
  max-width: 100%;

  label{
    margin-bottom: 1.25rem;
    display: inline-block;
    font-size: 11px;
    line-height: 1.2;
    letter-spacing: 0.2em;
    color: var(--secondaryColor);
    text-transform: uppercase;
    font-weight: 700; 
  }
  input{
    width: 100% !important;
  }
  input,select{
    background-color: initial;
    max-width: 100%;
    width: auto;
  }
select{
  width: auto;
}

  &:focus-within{
    border: 1px solid #015ad729;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }


`;



// Buttons
export const InvertedBtn = styled.button`
width: 11rem;
  &:hover{
  color: var(--thatYellow);
  background-color: unset;
  transform: scale(1.01);
}
`;

export const SocialBtn = styled.button`
width: 11rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;

  /* color: black; */
  display: inline-grid;
  place-items: center;
  grid-auto-flow: column;
  gap: .5rem;

 svg{
    font-size: 1.75rem;
  }
  img{
    filter: grayscale(1) invert(1);
    transition-duration: 500ms;
    }
&:hover{
  transform: scale(1.01) !important;
  img{
    filter: none;
    }
}

@media (max-width: 640px) { 
  display: flex;
  width: 100%;
  justify-content: center;

  img,svg{
    margin-left: .5rem;
  }
 }
`;

export const TwitterBtn = styled(SocialBtn)`

  color: #0088CC ;
  border-color: #0088CC;
  background-color: transparent;
  &:hover{
    background-color: #0088CC;
    color: var(--primaryColor);


  }
`;



export const TDiv = styled.div`
  border: 2px solid rgba(0, 0, 0, .08);
  border-radius: .375rem;
  color: #495057;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  div{
    padding: 1rem 1.25rem;
    border-bottom: .0625rem solid #e9ecef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 640px) { 
      align-items: start;
      flex-direction: column;

      p:first-child{
        margin-bottom: 0.275rem;
        text-transform: uppercase;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 1px;
      }
     }
    &:first-of-type{
      border-top-left-radius: .25rem;
      border-top-right-radius: .25rem;
    }
    &:last-of-type{
      border-bottom-right-radius: .375rem;
      border-bottom-left-radius: .375rem;
    }
  }
`;


export const DashCoin = styled(Link)`
  background-color: #F5F6FA;
  border-radius: 0.5rem;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* box-shadow: 0px 5px 8px 0 #0000002b; */
  .logo{
    background-color: #adadad;
    border-radius: 50%;
    height: 35px;
    width: 35px;
    /* display: none; */
  }
  h2{
    font-size: 1.15rem;
    font-weight: 600;
    letter-spacing: -0.01em;
    text-transform: capitalize;
  }
  b{
    font-size: 0.8rem;
    font-weight: 800;
    /* margin-bottom: 3px; */
    display: block;
    color: gray;
    text-transform: uppercase;
  }
`;

export const RecentAct = styled.div`
display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 1.25rem; */
    padding: 1.25rem 1.5rem;

    &:hover{
      background-color: #f5f6fa;
      cursor: pointer;
    }
    .refNo{
      font-weight: 700;
      margin-bottom: 0.25rem;
      text-transform: uppercase;
      b{
        font-weight: 700;
      }
    }
    .date{
      font-weight: 600;
      letter-spacing: -0.05em;
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: rgba(156, 163, 175, 1);
    }
    .coin{
      margin-bottom: 0.25rem;
      font-weight: 600;      
      font-size: 1rem/* 18px */;
      line-height: 1.75rem
    }
    &:not(:last-child) {
    border-bottom: 1px solid #dbdfea;
  }
`;

export const DashboardHeading = styled.div`
  h2{
    font-weight: 600;
    font-size: 1.75rem;
  }
`;

export const SellInput = styled.div`
  margin: 1.5rem 0;
 
  &>label,.label{
    font-size: .875rem;
    font-weight: 600;
    color: #344357;
    margin-bottom: 0.25rem;
    display: block;
  }
  div.input-div,select{
    /* min-height: calc(2.125rem + 2px); */
    font-size: 16px;
    padding:  0.75rem 1rem;
    display: block;
    width: 100%;
    
    color: #3c4d62;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #dbdfea;
    appearance: none;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
       border-radius: 5px;
    width: 100%;
  }
  .radio{
    display: flex;
    align-items: center;
    margin-right: 1.5rem;
    label{
      cursor: pointer;
      font-size: 1rem;
      margin-left: 0.25rem;
    }
  }
`;
